import btnStyle from '@/components/Shares/Button.module.css';
import inputStyle from '@/components/Shares/Input.module.css';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Badge, Button, Card, Flex, Group, Input, Stack, Text, rem } from '@mantine/core';
import classes from './AccountInfo.module.css';
export const InfoEmailCard: React.FC = () => {
  const verify = true;
  const {
    i18n
  } = useLingui();
  return <Card radius={5} bg="var(--bg-400)" p={{
    base: 10,
    sm: 20
  }} style={{
    overflow: 'visible'
  }}>
      <Stack gap={24} py={{
      base: 10,
      sm: 12
    }}>
        <Group gap={10} align="center">
          <Text fz={{
          base: 14,
          sm: 18
        }} lh={{
          base: rem(14),
          sm: rem(18)
        }} className={gunterzBold.className}>
            {i18n._('Email')}
          </Text>
          {verify && <Badge size="md" variant="light" radius={5} mb={5} classNames={{
          root: classes.badge
        }}>
              {i18n._('Verified')}
            </Badge>}
        </Group>

        <Stack gap={14}>
          <Text fz="xs" tt="uppercase" fw={700} c="var(--text-dark)">
            {i18n._('Verify your email address is valid and accessible by you.')}
          </Text>
          <Flex direction={{
          base: 'column',
          sm: 'row'
        }} gap={10}>
            <Input flex={1} maw={{
            lg: 485
          }} classNames={{
            input: inputStyle.input_style_2
          }} placeholder={i18n._('Enter your email')} />
            <Group gap={10} ml={{
            base: 'auto',
            sm: 0
          }}>
              <Button h={40} classNames={{
              root: btnStyle.button_style_2
            }}>
                {i18n._('Resend email')}
              </Button>
              <Button h={40} w={96} classNames={{
              root: btnStyle.button_style_2
            }}>
                {i18n._('Save')}
              </Button>
            </Group>
          </Flex>
        </Stack>
      </Stack>
    </Card>;
};